<template>
  <div class="textEdit">
    <div
      ref="quillEditorImgPicker"
      class="upload_one"
      id="quillEditorImgPicker"
    ></div>
    <div
      ref="quillEditorVideoPicker"
      class="upload_two"
      id="quillEditorVideoPicker"
    ></div>
    <quill-editor
      class="editor"
      v-model="mycontent"
      ref="myQuillEditor"
      :disabled="disabled"
      :options="editorOption"
    ></quill-editor>
  </div>
</template>
<script>
import { initwebupload } from "@/utils/webuplaoderCon";
import { quillEditor, Quill } from "vue-quill-editor";
import Video from "@/utils/video";
import "quill/dist/quill.snow.css";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
Quill.register(Video, true);
export default {
  name: "textEditPlus",
  components: {
    quillEditor
  },
  props: {
    height: {
      type: String,
      default: () => {
        return "300px";
      }
    },
    content: {
      type: String,
      default: () => {
        return "";
      }
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      editor: null,
      editorOption: {
        header: {
          // token: sessionStorage.token
        }, // 有的图片服务器要求请求头需要有token
        // serverUrl: "http://test.cystorage.cycore.cn/v2/files/upload", // 这里写你要上传的图片服务器地址
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              [{ script: "sub" }, { script: "super" }], // 上标/下标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              // [{'direction': 'rtl'}],                         // 文本方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ font: [] }], // 字体种类
              [{ align: [] }], // 对齐方式
              ["clean"], // 清除文本格式
              ["link", "image", "video"] // 链接、图片、视频
            ], // 工具菜单栏配置
            handlers: {
              video: (val) => {
                const quillEditorVideoPicker =
                  this.$refs.quillEditorVideoPicker;
                const _input =
                  quillEditorVideoPicker.querySelectorAll("input")[0];
                _input.click();
              },
              image: () => {
                const quillEditorImgPicker = this.$refs.quillEditorImgPicker;
                const _input =
                  quillEditorImgPicker.querySelectorAll("input")[0];
                _input.click();
              }
            }
          },

          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageDrop: false, // 拖动加载图片
          imageResize: {
            // 图片调整大小
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize"] // 'Toolbar'
          }
        },
        placeholder: "", // 提示
        readyOnly: false, // 是否只读
        theme: "snow", // 主题 snow/bubble
        syntax: true // 语法检测
      }
    };
  },
  computed: {
    mycontent: {
      get() {
        return this.content;
      },
      set(val) {
        this.$emit("changeContent", val);
      }
    }
  },
  methods: {
    initRich() {
      const editor = this.$refs.myQuillEditor;
      if (editor && editor.quill) {
        editor.quill.enable(false);
        setTimeout(() => {
          editor.quill.enable(true);
        }, 0);
      }

    },
    fileUploadFun() {
      initwebupload("#quillEditorImgPicker", "images", this.backFun);
      initwebupload("#quillEditorVideoPicker", "video", this.backFun);
    },
    // 回调方法
    backFun(backValue) {
      const quill = this.$refs.myQuillEditor.quill;
      const length = quill.selection.savedRange.index;
      if (backValue.name.id === "#quillEditorImgPicker") {
        quill.insertEmbed(length, "image", backValue.fileUrl);
      } else {
        quill.insertEmbed(length, "video", backValue.fileUrl);
      }

    },
    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },

    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      const quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.code === 200) {
        // 获取光标所在位置
        const length = quill.getSelection().index;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.result.url);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    }
  },
  mounted() {
    this.fileUploadFun();
  }
};
</script>
<style lang="less" scoped>
.textEdit {
  background-color: #fff;
  width: 100%;
  /deep/ .ql-formats {
    /deep/.ql-video {
      width: unset !important;
      display: flex;
      width: 48px;
      align-items: center;
    }
  }

  /deep/.ql-image {
    display: flex;
    width: 48px;
    align-items: center;
  }
  /deep/.ql-link {
    display: flex;
    width: 48px;
    align-items: center;
  }
  /deep/ video {
    width: 500px;
    height: 300px;
  }
  /deep/.webuploader-pick-new {
    background: none;
  }

  .ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
  }

  .ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
    content: "10px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
    content: "18px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
    content: "32px";
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体";
  }

  /deep/ .ql-snow .ql-editor img {
    max-width: 100% !important;
  }
  /deep/ .ql-container {
    // 暂时注释，将高度固定
    // height: calc(100% - 70px) !important;
    // min-height: 500px !important;
    height: 600px;
  }
}
/deep/ #quillEditorImgPicker {
  height: 1px;
  z-index: -1;
}
/deep/ #quillEditorVideoPicker {
  height: 1px;
  z-index: -1;
}

.editor {
  line-height: normal !important;
  video {
    width: 100% !important;
    height: 400px !important;
  }
}
</style>
